import api from "./api";

/**
 * Fatura & Makbuz uçları (backend: /api/invoices).
 */
export const invoiceService = {
  create: (payload) => api.post("/invoices", payload),
  list: () => api.get("/invoices"),
  get: (id) => api.get(`/invoices/${id}`),
  getByReference: (type, id) => api.get("/invoices/reference", { params: { type, id } }),
  cancel: (id) => api.post(`/invoices/${id}/cancel`),
  reportSummary: (from, to, granularity) =>
    api.get("/invoices/reports/summary", { params: { from, to, granularity } }),
};
